import {Component, Inject, LOCALE_ID, Renderer2} from '@angular/core';
import {hingeInFromTop, slideIn} from "../../../../base/animations/component.animation";
import {MenuGroup, MenuItem} from "./menu.model";
import {NavigationStart, Router} from "@angular/router";
import {Utility} from "../../../common/modules/utility/utility";
import {LocalStorageService} from "../../../../base/services/storage/localstorage.service";
import {Locales, MenuTypeKey, MenuTypes} from "../../../../models/global.config";
import {IParams} from "../../../../base/endpoints/iparams";
import {EventKey} from "../../../../registry/event.key";
import {DashEndpoint} from "../../../dash/dash.endpoint";
import {MetaData} from "ng-event-bus/lib/meta-data";
import {EventBusService} from "../../../../base/services/eventbus/event-bus.service";
import {SubscriptionContainerService} from "../../../../base/services/subscription-container.service";
import {BlogMenuService} from "../../../dash/domains/website/blogmenus/services/blogmenu.service";
import {BaseComponent} from "../../../../base/components/base.component";
import {document} from "ngx-bootstrap/utils";
import {IPage} from "../../../../base/models/pagination.model";
import {IBlogMenu} from "../../../dash/domains/website/blogmenus/models/blogmenu.model";
import {NotifierService} from "../../../../base/services/notifier/notifier.service";
import {TextUtility} from "../../../common/modules/utility/text.utility";

@Component({
  selector: 'blog-left-nav',
  templateUrl: './blog-left-nav.component.html',
  styleUrls: ['./blog-left-nav.component.scss'],
  animations: [
    hingeInFromTop('expanded'),
    slideIn('slideIn', 'left'),
  ]
})
export class BlogLeftNavComponent extends BaseComponent {

  isMenuCollapsed = false
  menu: MenuGroup[] = []
  menuType: MenuTypes = MenuTypes.HORIZONTAL

  blogSlug: string | null = null

  constructor(
    eventBus: EventBusService,
    private renderer: Renderer2,
    router: Router,
    subContainer: SubscriptionContainerService,
    @Inject(LOCALE_ID) protected locale: string,
    private blogMenuService: BlogMenuService,
    private notifier: NotifierService
  ) {
    super(eventBus, router, subContainer);

    this.blogSlug = TextUtility.extractSlug('blog', this.router.url)
    this.setActiveMenuItem(this.router.url)

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.setActiveMenuItem(event.url)
      }
    });

    LocalStorageService.put(MenuTypeKey.BLOG, MenuTypes.HORIZONTAL) // force use of horizontal menu for blog
    LocalStorageService.retrieveAsync(MenuTypeKey.BLOG, (mt) => {
      this.menuType = (mt as MenuTypes) || MenuTypes.HORIZONTAL
    })
  }

  protected componentName(): string {
    return BlogLeftNavComponent.name;
  }

  ngOnInit(): void {
    let blogSlug = this.extractBlogSlug(this.router.url)
    this.fetchBlogMenus(blogSlug!!, {
      page: 0,
      size: 10,
      sort_by: "id", // should change with `position` when implemented,
      sort_direction: "DESC"
    }, result => {
      this.menu = this.buildMenu(result)
    })
  }

  private extractBlogSlug(url: string): string | null {
    const segments = url.split('/');
    // Assuming the blog name is always the second segment after "/blog/"
    if (segments.length > 2 && segments[1] === 'blog') {
      return segments[2];
    }
    return null;
  }


  showHorizontalMenu() {
    return this.menuType === MenuTypes.HORIZONTAL && !Utility.isTabletOrMobileScreen
  }

  toggleLeftMenu() {
    if (!Utility.isTabletOrMobileScreen) {
      return
    }
    const body = document.body;

    body.classList.toggle('sidebar-enable');
    if (window.innerWidth <= 992) {
      body.classList.toggle('vertical-collpsed');
      console.log(this.isMenuCollapsed)
      this.isMenuCollapsed = !this.isMenuCollapsed
      console.log(this.isMenuCollapsed)
    }

    if (body.classList.contains('vertical-collpsed')) {
      this.renderer.addClass(body, 'vertical-collpsed');
      this.isMenuCollapsed = true
    } else {
      this.renderer.removeClass(body, 'vertical-collpsed');
      this.isMenuCollapsed = false
    }
  }

  expandSidebar(expand: boolean) {
    const body = document.body;
    console.log(this.isMenuCollapsed)
    this.isMenuCollapsed = !expand
    console.log(this.isMenuCollapsed)
    if (!expand) {
      body.classList.add('sidebar-enable');
      body.classList.add('vertical-collpsed');
    } else {
      body.classList.remove('sidebar-enable');
      body.classList.remove('vertical-collpsed');
    }

    if (Utility.isTabletScreen && !this.isMenuCollapsed) {
      this.menu = this.menu.map((g: MenuGroup) => {
        g.expanded = true
        return g
      })
    }
  }


  private setActiveMenuItem(url: string) {
    this.menu = this.menu.map((g: MenuGroup) => {
      let items = g.items.map(i => {
        i.selected = url.includes(i.link)
        return i
      })
      g.items = items
      g.expanded = items.some(i => i.selected)
      return g
    })

    if (Utility.isTabletScreen) {
      this.expandSidebar(false)
    }
  }


  onMenuGroupClick(item: MenuGroup) {
    if (item.link == null) return
    if (item.link.includes("http")) {
      window.location.href = item.link
    } else {
      let url = '/blog/' + this.blogSlug + item.link
      console.log(url)
      this.router.navigateByUrl(url).then(r => {
      })
    }
  }

  onMenuItemClick(item: MenuItem) {
    if (Utility.isMobileScreen) {
      this.toggleLeftMenu()
    }
    if (item.link.includes("http")) {
      window.location.href = item.link
    } else {
      this.router.navigateByUrl('/blog/' + this.blogSlug + item.link).then(r => {
      })
    }
  }

  private fetchBlogMenus(blogSlug: string, params: IParams, then: (result: IPage<IBlogMenu>) => void) {
    this.loading = true
    const key = this.componentKey(EventKey.BLOGMENUS.SEARCH(params))
    this.blogMenuService.search(key, DashEndpoint.BLOGMENUS.SEARCH_ENDPOINT_PUBLIC(blogSlug), params)
    this.subscribe(
      key,
      null,
      (value: Boolean, meta: MetaData) => {
        this.loading = false
        then(meta.data)
      })
    this.subscribe(this.getErrorKey(key), null, (value, meta) => {
      this.notifier.error('Error', meta.data.error.message)
    })
  }


  protected readonly Locales = Locales;

  private buildMenu(result: IPage<IBlogMenu>): MenuGroup[] {
    let rootMenus = result.content.filter(m => {
      return m.parent_id === null
    })
    return rootMenus.map((m) => {
      return {
        title: m.title,
        expanded: true,
        icon: m.image ?? '',
        link: m.link,
        items: this.findChildren(result.content, m.id).map(cm => {
          return {
            title: cm.title,
            icon: cm.image ?? '',
            link: cm.link ?? '',
            selected: true,
            children: [],
            permissions: [],
          }
        }),
      };
    });
  }

  findChildren(menus: IBlogMenu[], parentId: number) {
    return menus.filter(value => {
      return value.parent_id === parentId
    })
  }
}

